import { render, staticRenderFns } from "./layout-nav.vue?vue&type=template&id=5a774510&scoped=true&"
import script from "./layout-nav.vue?vue&type=script&lang=js&"
export * from "./layout-nav.vue?vue&type=script&lang=js&"
import style0 from "./layout-nav.vue?vue&type=style&index=0&id=5a774510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a774510",
  null
  
)

export default component.exports